import React from 'react';
import { withRouter, RouteComponentProps, matchPath } from 'react-router-dom';
import { connect, ConnectedProps } from 'react-redux'

import protocolsService from '../../../../services/protocols.service';

import { IChoiceField, IDateTimeField, IField, IFilterEF, INumberField, IProtocol, IQueryCriteriaEF } from '../../../../shared/interfaces';
import {
    IProtocolsSearchPageResult
} from '../../../../shared/interfacesDTO';

import {
    Selection, DetailsList, DetailsListLayoutMode, IColumn, Icon, Text, IDetailsListStyles, IDetailsRowProps,
    IRenderFunction, Link, mergeStyleSets, MessageBarType, MessageBar, SelectionMode, CheckboxVisibility,
    TooltipHost, DetailsHeader, ContextualMenu, IContextualMenuItem, TooltipOverflowMode, ITooltipHostStyles,
    IDetailsColumnStyles, IDetailsColumnFieldProps, Panel, PanelType, PrimaryButton, DefaultButton, ICommandBarItemProps, CommandBar, IButtonProps, ICommandBarStyles
} from '@fluentui/react';
import { reduxActions, RootState } from '../../../../store';

import CircleLoader from '../../../Loader/CircleLoader/CircleLoader';
import { Protocol_State, Protocol_Type, SortEF_Direction, Visibility_Type, Visibility_Type_Label } from '../../../../shared/enums';

import axios, { CancelTokenSource } from 'axios';
import AppUtilities from '../../../../shared/Utilities/appUtilities';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { myTheme } from '../../../../assets/styles/my-theme';
import DynamicForm from '../../../DynamicForm/DynamicForm';
import CustomCommandBarButton from '../../../CustomFluentUI/CustomCommandBarButton/CustomCommandBarButton';
import CustomCommandBarMenuItem from '../../../CustomFluentUI/CustomCommandBarMenuItem/CustomCommandBarMenuItem';
import { toastRef } from '../../../Layout/Layout';
import TableIconProprietario from '../../../../sharedComponents/TableIconProprietario';
import TableIconInoltro from '../../../../sharedComponents/TableIconInoltro';
import TableIconCopiaConoscenza from '../../../../sharedComponents/TableIconCopiaConoscenza';
import TableIconVisibilita from '../../../../sharedComponents/TableIconVisibilita';

const { palette } = myTheme;

const classNames = mergeStyleSets({
    fileIconHeaderIcon: {
        padding: 0,
        fontSize: '16px',
    },
    fileIconCell: {
        textAlign: 'center',
        selectors: {
            '&:before': {
                content: '.',
                display: 'inline-block',
                verticalAlign: 'middle',
                height: '100%',
                width: '0px',
                visibility: 'hidden',
            },
        },
    },
    fileIconImg: {
        verticalAlign: 'middle',
        maxHeight: '16px',
        maxWidth: '16px',
    },
    controlWrapper: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    exampleToggle: {
        display: 'inline-block',
        marginBottom: '10px',
        marginRight: '30px',
    },
    selectionDetails: {
        marginBottom: '20px',
    },
    tableIcons: {
        fontSize: '1.5em'

    },
    iconField: {
        padding: '5px',
        width: '28px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'


    },
    iconFieldHeader: {
        padding: 0,
        fontSize: '16px',
    },
    filtriCommandBar: {
        paddingTop: '20px'
    },
    emptyColumn: {}

});

const overflowProps: IButtonProps = {
    menuProps: {
        contextualMenuItemAs: CustomCommandBarMenuItem,
        items: []
    },
};

const filtriCommandBarStyles: Partial<ICommandBarStyles> = {
    root: { padding: '0 24px', borderBottom: '1px solid #eee' }

}

const tooltipHostStyles: Partial<ITooltipHostStyles> = {
    root: {
        display: 'inline-block',
        maxWidth: '100%',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'

    }
};

const detailsListStyles: Partial<IDetailsListStyles> = {
    root: {
        overflow: 'visible'
    }
}

const iconHeaderStyles: Partial<IDetailsColumnStyles> = {
    root: {
        width: '28px !important',
        padding: 0
    },
    cellTitle: {
        alignItems: 'center',
        justifyContent: 'center',
        padding: 0
    }

}

const initialSearchFields: IField[] = [
    {
        decimals: 0,
        percentage: false,
        displayName: "Numero protocollo",
        internalName: "NumeroProtocollo",
        sharepointType: "Number",
        controlType: "textbox",
        required: false,
        readonly: false,
        disabled: false,
        system: false,
        internalValue: "",
        valid: false,
        touched: false
    } as INumberField,
    {
        dateOnly: true,
        displayName: "Data Protocollo",
        internalName: "DataProtocollo",
        sharepointType: "Date",
        controlType: "calendar",
        required: false,
        readonly: false,
        disabled: false,
        rangeMode: true,
        internalValue: "",
        valid: false,
        touched: false

    } as IDateTimeField,
    {
        displayName: "Tipo Protocollo",
        internalName: "TipoProtocollo",
        sharepointType: "Choice",
        controlType: "dropdown",
        required: false,
        readonly: false,
        disabled: false,
        system: false,
        internalValue: "",
        valid: false,
        touched: false,
        options: [
            { key: Protocol_Type.DocumentoInEntrata, text: "Documento in Entrata" },
            { key: Protocol_Type.DocumentoInUscita, text: "Documento in Uscita" },
            { key: Protocol_Type.DocumentoInterno, text: "Documento Interno" }
        ]

    } as IChoiceField,

    {
        displayName: "Oggetto Protocollo",
        internalName: "OggettoProtocollo",
        sharepointType: "Text",
        controlType: "textbox",
        required: false,
        readonly: false,
        disabled: false,
        system: false,
        internalValue: "",
        valid: false,
        touched: false

    }
];

const queryString = require('query-string');

const mapState = (state: RootState) => ({
    currentUser: state.sessionReducer.currentUser,
    currentUor: state.sessionReducer.currentUor,
    currentAoo: state.sessionReducer.currentAoo,
    tuttiIProtocolliViewFields: state.sessionReducer.tuttiIProtocolliViewFields,
    campiRicercaFields: state.sessionReducer.campiRicercaViewFields,
    isMobile: state.sessionReducer.isMobile
})
const mapDispatch = {
    setProtocol: (protocol: IProtocol) => (reduxActions.appNavigationActions.setProtocol(protocol)),
}


const connector = connect(mapState, mapDispatch);
type PropsFromRedux = ConnectedProps<typeof connector>

export interface AddProtocolReferencesPanelProtocolsTableState {
    columns: IColumn[];
    items: (IProtocol | null)[];
    totalCount: number;
    selectedProtocol?: IProtocol

    filtriCommandBarItems: ICommandBarItemProps[];

    isLoadingProtocols: boolean,

    showContextualMenu: boolean
    contextMenuItems: IContextualMenuItem[] | undefined
    contextMenuPosition: any

    queryCriteria: IQueryCriteriaEF;
    searchPanelIsOpen: boolean;
    searchFormFields: IField[];
}
export interface AddProtocolReferencesPanelProtocolsTableProps {
    onSelectionChanged: (selectedProtocols: IProtocol[]) => void;
    selectionMode: SelectionMode
    showFilterCommandBar?: boolean
    disableProtocolNavigation?: boolean
    staticFilters?: IFilterEF[]
    forceTableRefresh?: boolean;
    onDownloadAllButtonClick?: () => void;
    deleteDraftHandler?: () => void;
    createProtocolFromHandler?: () => void;
}

type Props = AddProtocolReferencesPanelProtocolsTableProps & RouteComponentProps & PropsFromRedux

class AddProtocolReferencesPanelProtocolsTable extends React.Component<Props, AddProtocolReferencesPanelProtocolsTableState> {

    cancelTokenSources = {};

    private protocolSelection: Selection;

    constructor(props) {
        super(props);

        this.protocolSelection = new Selection({
            onSelectionChanged: () => {
                const selection = this.protocolSelection.getSelection() as IProtocol[];
                this.props.onSelectionChanged(selection);
                this.setState({
                    selectedProtocol: selection[0]
                }, () => { this.updateCommandBarItems() });
            },
        });

        this.state = {
            columns: [],
            items: [],
            totalCount: 0,

            filtriCommandBarItems: [],

            isLoadingProtocols: true,

            showContextualMenu: false,
            contextMenuItems: [],
            contextMenuPosition: undefined,

            queryCriteria: { pageNumber: 1, pageSize: 500, filters: [...(this.props.staticFilters ?? [])], sorts: [] },
            searchFormFields: [...initialSearchFields],
            searchPanelIsOpen: false,

        };
    }


    componentDidMount() {
        this.updateCommandBarItems();

        /// currentAoo è già valorizzate al mount quando faccio routing da una 
        /// pagina qualsiasi verso una contenente AddProtocolReferencesPanelProtocolsTable
        if (this.checkUor() && this.props.currentAoo && this.props.tuttiIProtocolliViewFields) {
            let columns = this.setColumns();
            this.setState({
                columns,
                isLoadingProtocols: true,
            }, () => { this.getProtocolli() });

        }
    }


    componentDidUpdate(oldProps: Props, oldState: AddProtocolReferencesPanelProtocolsTableState) {
        /// dopo il refresh pagina currentUor passa da undefined a valorizzato
        /// oppure se cambio uor
        if (this.checkUor() &&
            ((oldProps.currentUor !== this.props.currentUor && this.props.tuttiIProtocolliViewFields)
                || (this.props.currentUor && !oldProps.tuttiIProtocolliViewFields && this.props.tuttiIProtocolliViewFields))) {
            let columns = this.setColumns();
            this.setState({
                columns,
                isLoadingProtocols: true,
                items: [],
                queryCriteria: { pageNumber: 1, pageSize: 500, filters: [...(this.props.staticFilters ?? [])], sorts: [] },
            }, () => {
                this.updateCommandBarItems();
                this.getProtocolli()
            });
        }
        if (oldProps.forceTableRefresh !== this.props.forceTableRefresh) {
            this.setState({
                isLoadingProtocols: true,
                items: []
            }, () => {
                this.updateCommandBarItems();
                this.getProtocolli()
            });
            this.protocolSelection.setItems([]);
        }
    }

    componentWillUnmount() {

        // cancello tutte le request in pending
        for (const [key, value] of Object.entries<CancelTokenSource>(this.cancelTokenSources)) {
            value.cancel(`${key} canceled`)
        }

    }

    getProtocolli = () => {
        const { location, match } = this.props;
        let aooId: number = Number(match.params['aooId']);
        const parsedQueryString = queryString.parse(location.search);
        let uorId: number | undefined = parsedQueryString.uorId ? Number(parsedQueryString.uorId) : undefined;

        if (aooId && uorId) {


            // se in cancelTokenSources c'è il cancelToken associato alla chiamata
            // chiamo il metodo cancel che interrompe la chiamata in pending
            this.cancelTokenSources[protocolsService.getProtocolsUor.name]?.cancel(protocolsService.getProtocolsUor.name + " Request annullata");
            // Ricreo il cancel token ad ogni request
            this.cancelTokenSources[protocolsService.getProtocolsUor.name] = axios.CancelToken.source();


            this.setState({ isLoadingProtocols: true })
            let { queryCriteria, totalCount } = this.state;

            protocolsService.getProtocolsUor(aooId, uorId, queryCriteria, this.cancelTokenSources[protocolsService.getProtocolsUor.name].token)
                .then((result: IProtocolsSearchPageResult) => {
                    const pageItems = result.items ?? [];
                    const newTotalCount = result.totalCount ?? totalCount;

                    const currentItems = this.removeNullPlaceholders(this.state.items);

                    const mergedItems: (IProtocol | null)[] = [...currentItems, ...pageItems];
                    const nextPageNumber = queryCriteria.pageNumber + 1;

                    if (mergedItems.length < (newTotalCount ?? 0)) {
                        mergedItems.push(null);
                    }

                    this.setState(prevState => ({
                        items: mergedItems,
                        totalCount: newTotalCount ?? 0,
                        queryCriteria: {
                            ...prevState.queryCriteria,
                            pageNumber: nextPageNumber
                        },
                        isLoadingProtocols: false
                    }));



                    delete this.cancelTokenSources[protocolsService.getProtocolsUor.name];
                })
                .catch(error => {
                    if (axios.isCancel(error)) {
                        //se non metto il catch partono delle chiamate tipo: static/js/vendors~main.chunk.js.map
                        console.log(error.message);
                    }
                    else if (!error.isErrorShown) {
                        toastRef.current?.show({
                            severity: 'error',
                            summary: 'Attenzione',
                            detail: `Non è stato possibile recuperare i protocolli`,
                            life: 5000
                        });
                    }

                    this.setState({
                        isLoadingProtocols: false,
                    });
                    delete this.cancelTokenSources[protocolsService.getProtocolsUor.name];

                });

        }
    }

    updateCommandBarItems = () => {
        const newFiltriCommandBarItems: ICommandBarItemProps[] = [];

        newFiltriCommandBarItems.push(
            {
                key: 'filtri',
                commandBarButtonAs: () => (

                    <CustomCommandBarButton
                        text='Filtri'
                        key='Filtri'
                        iconPropsFontAwesome={{ icon: ['far', 'filter'] }}
                        onClick={this.onFiltriClick}
                    />

                )
            }
        );

        let filters = [...this.state.queryCriteria.filters]
        let staticFilters = [...(this.props.staticFilters ?? [])];
        let dynamicFilters = filters.filter(function (el) {
            return staticFilters.indexOf(el) < 0;
        });

        if (dynamicFilters.length > 0) {
            newFiltriCommandBarItems.push({
                key: 'resetFiltri',
                commandBarButtonAs: () => (
                    <CustomCommandBarButton
                        text='Reset filtri'
                        key='resetFiltri'
                        iconPropsFontAwesome={{ icon: ['fal', 'filter-slash'] }}
                        onClick={this.resetSearchHandler}
                    />
                )
            });
        }

        newFiltriCommandBarItems.push(
            {
                key: 'aggiornaAreaDiLavoro',
                text: 'Aggiorna',
                iconProps: { iconName: 'Refresh' },
                onClick: this.onAggiornaClick
            },
        );


        this.setState({
            filtriCommandBarItems: newFiltriCommandBarItems
        });
    }

    onFiltriClick = () => {
        this.setState({ searchPanelIsOpen: true });
    }

    // Click su cerca del panel laterale
    submitSearchPanelHandler = () => {

        let { searchFormFields, queryCriteria } = this.state;

        let touchedFields: IField[] = searchFormFields.filter((el: IField) => el.touched && el.internalValue);
        let fixedFields = AppUtilities.fixFieldsValueForSearchEFSubmit([...touchedFields]);

        let currentQueryCriteria: IQueryCriteriaEF = { ...queryCriteria, pageNumber: 1, filters: [...(this.props.staticFilters ?? []), ...fixedFields] };

        this.setState({
            searchPanelIsOpen: false,
            isLoadingProtocols: true,
            items: [],
            queryCriteria: currentQueryCriteria
        }, () => {
            this.getProtocolli();
            this.updateCommandBarItems()
        })
    }


    onAggiornaClick = () => {
        let { queryCriteria } = this.state;


        let currentQueryCriteria: IQueryCriteriaEF = { ...queryCriteria, pageNumber: 1 };

        this.setState({
            isLoadingProtocols: true,
            items: [],
            queryCriteria: currentQueryCriteria
        }, () => {
            this.getProtocolli();
            this.updateCommandBarItems()
        })

    }

    //metodo per resettare la ricerca
    resetSearchHandler = () => {
        let { searchFormFields, queryCriteria } = this.state;

        let newSearchFields = searchFormFields.map(el => {
            return { ...el, internalValue: null, touched: false };
        });

        let currentQueryCriteria: IQueryCriteriaEF = { ...queryCriteria, pageNumber: 1, filters: [...(this.props.staticFilters ?? [])] };

        this.protocolSelection.setAllSelected(false);

        this.setState({
            searchFormFields: newSearchFields,
            isLoadingProtocols: true,
            items: [],
            queryCriteria: currentQueryCriteria
        }, () => {
            this.getProtocolli();
            this.updateCommandBarItems()
        })

    }

    //metodo per resettare la form di ricerca
    resetSearchFieldsHandler = () => {
        let { searchFormFields } = this.state;

        let newSearchFields = searchFormFields.map(el => {
            return { ...el, internalValue: null, touched: false };
        });
        this.setState({
            searchFormFields: newSearchFields
        });
    }

    formSearchInputChangedHandler = (newField: IField) => {
        const updatedFormFields: IField[] = [...this.state.searchFormFields];
        let itemIndex = updatedFormFields.findIndex(el => el.internalName === newField.internalName);
        // se l'internalValue è null setto field.touched a false così viene ignorato durante la ricerca
        if (!newField.internalValue) {
            updatedFormFields[itemIndex] = { ...newField, touched: false };
        } else {
            updatedFormFields[itemIndex] = { ...newField };
        }
        this.setState({
            searchFormFields: updatedFormFields
        });

    }


    dismissSearchPanel = (ev?: React.SyntheticEvent<HTMLElement, Event> | KeyboardEvent | undefined) => {
        ev?.preventDefault();
        ev?.stopPropagation();
        this.setState({ searchPanelIsOpen: false })
    }

    checkUor() {
        const parsedQueryString = queryString.parse(this.props.location.search);
        let uorId: number | undefined = parsedQueryString.uorId ? Number(parsedQueryString.uorId) : undefined;

        if (uorId) {
            return true;
        }
        else if (this.props.currentAoo) {

            this.props.history.push({ pathname: `/${this.props.currentAoo.id}/ricerca` });
            return false;

        }
        else {

            return false;

        }
    }

    setColumns = (): IColumn[] => {

        let fields: IField[] = [...this.props.tuttiIProtocolliViewFields!];

        let _fields = fields.filter(f => !f.system
            && f.internalName !== 'ID'
            && f.internalName !== 'Title'
            && f.internalName !== 'Protocollo'
            && f.internalName !== 'Proprietario'
            && f.internalName !== 'CopiaConoscenza'
            && f.internalName !== 'Inoltro'
            && f.internalName !== 'Visibilita');


        let newColumns: IColumn[] = [
            {
                key: 'visibilita',
                name: 'visibilita',
                fieldName: 'visibilita',
                isIconOnly: true,
                styles: iconHeaderStyles,
                minWidth: 6,
                maxWidth: 6,
                onRenderField: this.onRenderVisibilitaField,
            },
            {
                key: 'hasAttachments',
                name: 'hasAttachments',
                fieldName: 'hasAttachments',
                isIconOnly: true,
                styles: iconHeaderStyles,
                minWidth: 7,
                maxWidth: 7,
                onRenderField: this.onRenderAttachmentField,
                onRenderHeader: () => {
                    return <Icon iconName="Attach" className={classNames.iconFieldHeader} />
                },

            },
            {
                key: 'annotazione',
                name: 'annotazione',
                fieldName: 'annotazione',
                isIconOnly: true,
                styles: iconHeaderStyles,
                minWidth: 7,
                maxWidth: 7,
                onRenderField: this.onRenderAnnotazioneField,
                onRenderHeader: () => {
                    return <Icon iconName="Message" className={classNames.fileIconHeaderIcon} />
                },

            },
            {
                key: 'Protocollo',
                name: 'Protocollo',
                fieldName: 'Protocollo',
                minWidth: 110,
                maxWidth: 110,
                isResizable: true
            }
        ];


        _fields.forEach(el => {
            const fieldFullProperties = this.props.tuttiIProtocolliViewFields?.find(it => it.internalName === el.internalName);
            const field = fieldFullProperties ? { ...fieldFullProperties } : { ...el };
            let col: IColumn = {
                key: field.internalName,
                fieldName: field.internalName,
                name: field.displayName,
                minWidth: 150,
                isResizable: true,
                ...field
            };
            if (field.internalName === 'DataProtocollo' || field.internalName === 'StatoProtocollo') {
                col.maxWidth = 110;
                col.minWidth = 110;
            } else if (field.internalName === "TipoProtocollo") {
                col.maxWidth = 140;
                col.minWidth = 140;
            }
            newColumns.push(col);
        });
        /// Aggiungo una colonna vuota in coda alla tabella, è necessaria per consentire l'allineamneto tra
        /// l'header e i contenuti della tabella 
        if (!this.props.isMobile) {
            newColumns.push(
                {
                    key: 'empty',
                    name: 'empty',
                    fieldName: 'empty',
                    isIconOnly: true,

                    className: classNames.emptyColumn,
                    headerClassName: classNames.emptyColumn,
                    minWidth: 1,
                    maxWidth: 1,
                    onRender: (item) => {

                    },
                },

            );
        }
        return newColumns;

    }

    extractDisplayValueAndColumnContent = (item: IProtocol | undefined, column: any) => {
        let displayValue = "-";
        let columnInternalName = column?.fieldName;

        let columnContent: any = displayValue;

        if (item) {
            let protocol: IProtocol = { ...item };
            const fieldContent = protocol.fields?.find(it => it.internalName === columnInternalName);
            if (fieldContent) {
                const fieldColumnMerge: IField = { ...column, internalValue: fieldContent?.internalValue };
                displayValue = AppUtilities.getDisplayValueFromFieldControlType(fieldColumnMerge);
                if (columnInternalName === 'Protocollo') {
                    if (protocol.statoProtocollo === Protocol_State.InCreazione || protocol.statoProtocollo === Protocol_State.InCreazioneDaMail) {
                        displayValue = "Bozza";
                    }
                    if (this.props.disableProtocolNavigation) {
                        columnContent = displayValue;
                    } else {
                        columnContent = (
                            <Link key={`link-protocol-${protocol.protocolId}`} onClick={(ev) => this.navigate(ev, item)}>{displayValue}</Link>
                        );
                    }
                }
                else {
                    switch (fieldColumnMerge.controlType) {
                        //case "autocompleteContact":
                        //    columnContent = (
                        //        <HoverCardContact field={fieldColumnMerge as IAutocompleteField} />
                        //    );
                        //    break;

                        case "calendar":
                        case "dropdown":
                        case "autocomplete":
                        case "autocompleteUser":
                        case "boolean":
                        case "textbox":
                        case "textarea":
                        default:
                            columnContent = displayValue;
                            break;


                    }

                }
            }
        }
        return { displayValue, columnContent };
    }


    navigate = (ev, item?: IProtocol) => {
        ev?.preventDefault();
        ev?.stopPropagation();
        if (item && item.protocolId) {
            this.props.setProtocol(item!);
            //aggiunge gli zeri prima del numero
            const zeroPad = (num, places) => String(num).padStart(places, '0');
            let protocolnumber = zeroPad(item.numeroProtocollo, 8) + '-' + item.annoProtocollo;
            let path;
            switch (item.statoProtocollo) {
                case Protocol_State.Protocollato:
                case Protocol_State.Acquisito:
                case Protocol_State.Annullato:
                    path = `/${this.props.currentAoo!.id}/${item.protocolId}/${protocolnumber}`;
                    break;
                case Protocol_State.Allocato:
                    path = `/${this.props.currentAoo!.id}/allocated/${item.protocolId}/${protocolnumber}`;
                    break;
                case Protocol_State.InCreazione:
                case Protocol_State.InCreazioneDaMail:
                    path = `/${this.props.currentAoo!.id}/edit/${item.protocolId}`;
                    break;

            }
            this.props.history.push({ pathname: path, search: this.props.location.search });
        }
    }

    onColumnHeaderClick = (ev: React.MouseEvent<HTMLElement> | undefined, column: IColumn | undefined): void => {
        ev?.preventDefault();
        ev?.stopPropagation();
        const { columns, queryCriteria } = this.state;

        let { location, match } = this.props;

        const parsedQueryString = queryString.parse(location.search);
        let uorId: number = Number(parsedQueryString.uorId);
        let aooId: number = Number(match.params['aooId']);


        if (column) {
            let newIsSortedDescending = !column.isSortedDescending;
            let newColumns = columns.map((col: IColumn) => {
                if (col.key === column.key) {
                    col.isSortedDescending = newIsSortedDescending;
                    col.isSorted = true;
                } else {
                    col.isSorted = false;
                    col.isSortedDescending = true;
                }
                return col;
            });

            let sortDirection = newIsSortedDescending ? SortEF_Direction.Descending : SortEF_Direction.Ascending;
            let currentQueryCriteria: IQueryCriteriaEF = {
                ...queryCriteria,
                pageNumber: 1,
                sorts: [{ fieldName: column.key, sortDirection: sortDirection }]
            }

            this.setState({
                isLoadingProtocols: true,
                columns: newColumns,
                items: [],
                queryCriteria: currentQueryCriteria
            }, () => {
                this.getProtocolli();
                //localStorage.setItem(`columns_${aooId}_${uorId}`, JSON.stringify(newColumns));

            })
        }
    }

    onRenderAttachmentField: IRenderFunction<IDetailsColumnFieldProps> = (columnProps, defaultRender) => {
        let iconContent: any = (<React.Fragment></React.Fragment>);
        if (columnProps && columnProps.item && columnProps.item.hasAttachments) {
            iconContent = (
                <Icon iconName="Attach" style={{ fontSize: 16 }} />
            );

        }
        return (
            <div key={`attachment-protocol-${columnProps!.item!.id}`} className={classNames.iconField} >
                <TooltipHost content="Allegato">
                    {iconContent}
                </TooltipHost>
            </div>
        );
    }

    onRenderAnnotazioneField: IRenderFunction<IDetailsColumnFieldProps> = (columnProps, defaultRender) => {
        let iconContent: any = (<React.Fragment></React.Fragment>);
        if (columnProps && columnProps.item && columnProps.item.hasNotes) {
            iconContent = (
                <Icon iconName="Message" style={{ fontSize: 16 }} />
            );

        }
        return (
            <div key={`annotation-protocol-${columnProps!.item!.id}`} className={classNames.iconField} >
                <TooltipHost content="Annotazione">
                    {iconContent}
                </TooltipHost>
            </div>
        );
    }

    onRenderStatoProtocolloField: IRenderFunction<IDetailsColumnFieldProps> = (columnProps, defaultRender) => {
        let iconContent: any = (<React.Fragment></React.Fragment>);
        if (columnProps && columnProps.item && columnProps.item.statoProtocollo === Protocol_State.Annullato) {
            iconContent = (
                <FontAwesomeIcon icon={{ prefix: 'fal', iconName: 'file-slash' }} style={{ fontSize: 16 }} />
            );

        }
        return (
            <div key={`state-protocol-${columnProps!.item!.id}`} className={classNames.iconField} >
                <TooltipHost content="Annullato">
                    {iconContent}
                </TooltipHost>
            </div>
        );
    }

    onRenderVisibilitaField: IRenderFunction<IDetailsColumnFieldProps> = (columnProps, defaultRender) => {
        if (columnProps && columnProps.item && columnProps.item.visibilita) {
            const arrayVisibilita = columnProps.item.visibilita;
            const visibilitaObj = arrayVisibilita.find(obj => obj.uor.id === this.props.currentUor!.id);
            let protocolId = columnProps.item.id;
            switch (visibilitaObj?.tipologia) {

                case Visibility_Type.Proprietario:
                    return (<TableIconProprietario key={`visibilita-protocol-${protocolId}`} />);

                case Visibility_Type.Inoltro:
                    return (<TableIconInoltro key={`visibilita-protocol-${protocolId}`} />);

                case Visibility_Type.CopiaConoscenza:
                    return (<TableIconCopiaConoscenza key={`visibilita-protocol-${protocolId}`} />);

                case Visibility_Type.Visibilita:
                    return (<TableIconVisibilita key={`visibilita-protocol-${protocolId}`} />);
                default:
                    return <div className={classNames.iconField} ></div>;

            }

        }
        return <div className={classNames.iconField} ></div>;
    }



    onRenderDetailsHeader = (detailsHeaderProps) => {
        const detailsListHeadrerStyles: Partial<IDetailsListStyles> = {

            root: { boxSizing: 'content-box !important' }

        };
        return (
            <DetailsHeader
                {...detailsHeaderProps}
                styles={detailsListHeadrerStyles}
            />
        );
    }


    onRenderItemColumn = (item?: IProtocol, index?: number | undefined, column?) => {
        let displayValue = "-";
        let columnContent: any | undefined;
        ({ displayValue, columnContent } = this.extractDisplayValueAndColumnContent(item, column));

        return (
            <TooltipHost
                content={displayValue}
                styles={tooltipHostStyles}
                overflowMode={TooltipOverflowMode.Self}
            >
                {columnContent}
            </TooltipHost>
        );
    }

    //metodo per il render dei bottoni nel panel
    onRenderSearchPanelFooter = () => {
        return (
            <React.Fragment>
                <PrimaryButton
                    styles={{ root: { marginRight: 8 } }}
                    text="Cerca"
                    onClick={this.submitSearchPanelHandler}

                />
                <DefaultButton
                    onClick={() => this.resetSearchFieldsHandler()}
                    text="Reset filtri"
                />
            </React.Fragment>
        );
    }

    private removeNullPlaceholders = (items: (IProtocol | null)[]) =>
        items.filter((item): item is IProtocol => item !== null);


    public render() {
        return (

            <React.Fragment>
                <div className="protocols-table-component">
                    <CircleLoader loaderClass='loader-large' loading={this.state.isLoadingProtocols} />

                    {this.props.showFilterCommandBar &&

                        <div className={classNames.filtriCommandBar} >
                            <CommandBar
                                overflowButtonProps={overflowProps}
                                items={this.state.filtriCommandBarItems}
                                styles={filtriCommandBarStyles}

                            />
                        </div>
                    }

                    {this.state.items.length > 0 &&
                        <DetailsList
                            className="with-empty-column"
                            styles={detailsListStyles}
                            items={this.state.items}
                            columns={this.state.columns}
                            onRenderItemColumn={this.onRenderItemColumn}
                            onRenderDetailsHeader={this.onRenderDetailsHeader}
                            layoutMode={DetailsListLayoutMode.justified}
                            selection={this.protocolSelection}
                            selectionPreservedOnEmptyClick={true}
                            selectionMode={SelectionMode.single}
                            checkboxVisibility={CheckboxVisibility.onHover}

                        />
                    }
                    {this.state.items.length === 0 && !this.state.isLoadingProtocols &&

                        <Text block style={{ padding: 25 }}>Non ci sono protocolli.</Text>
                    }


                    <Panel
                        isLightDismiss
                        isOpen={this.state.searchPanelIsOpen}
                        type={PanelType.custom}
                        customWidth={'600px'}
                        headerText={'Filtri di ricerca'}

                        onDismiss={this.dismissSearchPanel}
                        onRenderFooterContent={this.onRenderSearchPanelFooter}

                        closeButtonAriaLabel="Close"
                        isHiddenOnDismiss={false}
                    >

                        <div className={`search-form-dialog flex flex-column position-relative`}>

                            <div className={`position-relative my-scroll-div`}>
                                <div >
                                    <DynamicForm
                                        fields={this.state.searchFormFields}
                                        onInputChangedHandler={(newField) => { this.formSearchInputChangedHandler(newField) }}
                                    />

                                </div>

                            </div>

                        </div>
                    </Panel>
                </div>
            </React.Fragment>


        );
    }

}



export default connector(withRouter(AddProtocolReferencesPanelProtocolsTable));


